import React from "react";

const Tab: React.FunctionComponent<{ tabId: string }> = (props) => {
    function toggleTabs(tabId: string) {
        const tab_group_id: any = document.querySelector("#" + tabId);
        const toggleUser = document.querySelector("#user-profile-btn");

        if (toggleUser && tab_group_id && tab_group_id.classList.contains("is-visible")) {
            tab_group_id.classList.remove("is-visible");
            toggleUser.setAttribute("aria-expanded", "false");
        } else {
            if (toggleUser && tab_group_id) {
                tab_group_id.classList.add("is-visible");
                toggleUser.setAttribute("aria-expanded", "true");
            } else if (tab_group_id && tab_group_id.classList.contains("is-visible")) {
                tab_group_id.classList.remove("is-visible");
            } else if (tab_group_id) {
                tab_group_id.classList.add("is-visible");
            }
        }
    }

    return (
        <div className="row">
            <div className="col-xs-12">
                <div className="box no-padding">
                    <div className="tab-list" id={props.tabId}>
                        <div className="tab-toggle" role="presentation">
                            <button
                                type="button"
                                className="btn-default btn-no-padding btn-icon-only"
                                onClick={() => toggleTabs(props.tabId)}
                                aria-label="Show Menu Options"
                            >
                                <span className="btn-text">
                                    <span className="sr-only">Show Menu</span> Options
                                </span>
                                <span className="btn-helper">
                                    <em className="las la-angle-down"></em>
                                </span>
                            </button>
                        </div>
                        <ul className="list-reset" role="menu">
                            {props.children}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Tab;
